import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import PersonalDataCard from "@/shared/widgets/PersonalDataCard";
import { EstateState } from "@/domains/estate/slice";

type Props = {
  residents: EstateState["tenants"]["data"];
  onChange: (id: number) => void;
  onCall: (id: number) => void;
  onMsg: (id: number) => void;
  className?: string;
};

export default function EstateTenantsList({
  className,
  residents,
  onChange,
  onCall,
  onMsg,
}: Props) {
  const { t } = useTranslation("estate");

  const onCallHandler = useCallback((id: number) => {
    onCall(id);
  }, []);

  const onMsgHandler = useCallback((id: number) => {
    onMsg(id);
  }, []);

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      {residents.map((item, index) =>
        item ? (
          <PersonalDataCard
            key={item.characterId}
            name={item.name}
            id={item.characterId}
            isOnline={typeof item.playerMpId === "number"}
            onClick={() => onChange(item.characterId)}
            onCall={() => onCallHandler(item.characterId)}
            onMsg={() => onMsgHandler(item.characterId)}
          />
        ) : (
          <div
            key={`${index + index}`}
            className={clsx(
              "h-[3.5rem] flex items-center px-5 uppercase text-10 font-bold text-white/50",
              "border border-dashed border-[#1A1A1A] rounded-[0.625rem] bg-clip-padding px-5",
            )}
          >
            {t("estate.emptyPlace")}
          </div>
        ),
      )}
    </div>
  );
}
